var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import EdButton from "../../../../../../web/components/generic/edbutton/edButton";
import YobInputField from "../../../../../../shared-library/components/OtpGeneric";
import Timmer from "../../../../../../web/components/generic/Timmer";
import leadDI from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import Edelicon from "../../../../../../shared-library/components/Generic/Edelicon";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
var ClientEmailVerifyPopUp = function (props) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    var tempTextValidateRegex = /@.*(temp|tmp)/i;
    var _a = __read(useState(false), 2), isOTPsent = _a[0], setIsOTPsent = _a[1];
    var _b = __read(useState(false), 2), otpError = _b[0], setOtpError = _b[1];
    var _c = __read(useState(false), 2), otpTimer = _c[0], setOtpTimer = _c[1];
    var _d = __read(useState(false), 2), isLoader = _d[0], setIsLoader = _d[1];
    var _e = __read(useState(false), 2), emailVerificationSuccess = _e[0], setEmailVerificationSuccess = _e[1];
    var _f = __read(useState(false), 2), verificationLinkSuccess = _f[0], setVerificationLinksuccess = _f[1];
    var _g = __read(useState(false), 2), verificationLinkFailure = _g[0], setVerificationLinkFailure = _g[1];
    var _h = __read(useState(""), 2), inputFieldError = _h[0], setInputFieldError = _h[1];
    var _j = __read(useState((props === null || props === void 0 ? void 0 : props.prevEmailID) ? props === null || props === void 0 ? void 0 : props.prevEmailID : ""), 2), newEmailID = _j[0], setNewEmailID = _j[1];
    var _k = __read(useState(""), 2), otp = _k[0], setOtp = _k[1];
    var _l = __read(useState(""), 2), otpID = _l[0], setOTPID = _l[1];
    var sendOTPforEmail = function () {
        var payload = {
            contactInfo: newEmailID,
            otptype: "email",
        };
        leadDI.leads
            .getLeadOtp(payload)
            .then(function (resp) {
            setIsOTPsent(true);
            setOTPID(resp === null || resp === void 0 ? void 0 : resp.otpId);
        })
            .catch(function (error) {
            console.log("error", error);
        });
    };
    var clientEmailUpdate = function () {
        var payload = {
            email: newEmailID,
            uccCode: props === null || props === void 0 ? void 0 : props.uccCode,
            // email: "NW24130553@gmail.com",
            // uccCode: "NW24130553",
            source: leadStatusConfig.SalesSourceName,
        };
        leadDI.leads
            .clientEmailUpdate(payload)
            .then(function (resp) {
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.success)) {
                setEmailVerificationSuccess(true);
                props === null || props === void 0 ? void 0 : props.getUCCStatus();
            }
            else {
                setEmailVerificationSuccess(false);
            }
        })
            .catch(function (error) {
            setEmailVerificationSuccess(false);
        });
    };
    var verifyOtp = function (OTP) {
        setIsLoader(true);
        var payloadValidateOtp = {
            otpId: otpID,
            otp: OTP,
        };
        leadDI.leads
            .getValidateOtp(payloadValidateOtp)
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.status) {
                setOtpError(false);
                clientEmailUpdate();
            }
            setIsLoader(false);
        })
            .catch(function (error) {
            setOtpError(true);
            setIsLoader(false);
        });
    };
    var checkUCCdedup = function (isFromSentVerification) {
        var _a;
        if (isFromSentVerification === void 0) { isFromSentVerification = false; }
        var payload = {
            email: newEmailID,
            mobile: (_a = props === null || props === void 0 ? void 0 : props.mobileNumber) !== null && _a !== void 0 ? _a : "",
            source: leadStatusConfig.SalesSourceName,
        };
        leadDI.leads
            .checkUccDedup(payload)
            .then(function (resp) {
            var _a;
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0 && ((_a = resp[0]) === null || _a === void 0 ? void 0 : _a.isallow) === "Y") {
                isFromSentVerification ? sendVerificationLink() : sendOTPforEmail();
            }
        })
            .catch(function (resp) {
            var _a, _b, _c;
            var resErrors;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.getErrorsObject()) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                resErrors = resp.getErrorsObject();
                if ((_b = resErrors[0]) === null || _b === void 0 ? void 0 : _b.message) {
                    setInputFieldError((_c = resErrors[0]) === null || _c === void 0 ? void 0 : _c.message);
                }
                else {
                    setInputFieldError("The entered email id is already mapped to a different UCC. Please use a different email id.");
                }
            }
        });
    };
    var sendVerificationLink = function () {
        var _a, _b;
        setIsLoader(true);
        var reqObj = {
            mobile: (_a = props === null || props === void 0 ? void 0 : props.mobileNumber) !== null && _a !== void 0 ? _a : "",
            email: newEmailID,
            isClient: true,
            uccCode: (_b = props === null || props === void 0 ? void 0 : props.uccCode) !== null && _b !== void 0 ? _b : "",
            type: 2,
        };
        leadDI.leads
            .verificationLink(reqObj)
            .then(function (resp) {
            if (resp && resp.success) {
                setVerificationLinksuccess(resp.success);
            }
            else {
                setVerificationLinkFailure(true);
            }
            setIsLoader(false);
        })
            .catch(function (error) {
            setVerificationLinkFailure(true);
            setIsLoader(false);
        });
    };
    var getEmailValidationSuccess = function () {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center email-verify-success" },
            React.createElement("div", { className: "mb-4" },
                React.createElement(Edelicon, { className: "edel-icon-success-icon-fullgreen", paths: 5 })),
            React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue mb-1" }, "Successfully updated your Email ID"),
            React.createElement("span", { className: "DMSansNormal_12_400 txt_blue-tint mt-2 mb-4  text-center changed-email-block" },
                "The email ID has changed from ", props === null || props === void 0 ? void 0 :
                props.prevEmailID,
                " to ",
                newEmailID)));
    };
    var getVerificationLinkSuccess = function () {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center email-verify-success" },
            React.createElement("div", { className: "mb-4" },
                React.createElement(Edelicon, { className: "edel-icon-success-icon-fullgreen", paths: 5 })),
            React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue mb-1" }, "Link Sent Successfully"),
            React.createElement("div", { className: "DMSansNormal_12_400 txt_blue-tint mt-2 mb-4  text-center changed-email-block" }, "The client should verify through the link sent to their email '".concat(newEmailID, "'")),
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement("i", { className: "edel-icon-refresh me-1" }),
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Verify again", type: "button", onClick: function () {
                        setVerificationLinksuccess(false);
                        setEmailVerificationSuccess(false);
                    } }))));
    };
    var getVerificationLinkFailure = function () {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center email-verify-success" },
            React.createElement("div", { className: "mb-4" },
                React.createElement(Edelicon, { className: "edel-icon-featured-failure", paths: 5 })),
            React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue mb-1" }, "Sending Link Failed"),
            React.createElement("div", { className: "DMSansNormal_12_400 txt_blue-tint mt-2 mb-4  text-center changed-email-block" }, "Sending link to their email ID \u2018".concat(newEmailID, "\u2019 Failed due to a technical error. Please try again or try verifying with OTP")),
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement("i", { className: "edel-icon-refresh me-1" }),
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Verify again", type: "button", onClick: function () {
                        setVerificationLinkFailure(false);
                        setEmailVerificationSuccess(false);
                    } }))));
    };
    return (React.createElement("div", { className: "".concat((props === null || props === void 0 ? void 0 : props.parentClassName) ? props === null || props === void 0 ? void 0 : props.parentClassName : "", "\n    client-email-verify-popUp") }, isLoader ? (React.createElement(Loader, null)) : emailVerificationSuccess ? (getEmailValidationSuccess()) : verificationLinkSuccess ? (getVerificationLinkSuccess()) : verificationLinkFailure ? (getVerificationLinkFailure()) : (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { className: "txt_primaryGrey DMSanN_16_400 email-text " }, "Email ID"),
            React.createElement(InputField, { autoFocus: true, onChangeEvent: function (e) {
                    var _a;
                    setInputFieldError("");
                    setNewEmailID((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
                }, defaultValue: newEmailID, onBlur: function (error, event) {
                    var _a, _b, _c;
                    if (((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0 && !(error === null || error === void 0 ? void 0 : error.pattern)) {
                        setInputFieldError("This email id is invalid, please check the entered email id.");
                    }
                    else if (tempTextValidateRegex.test((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.value)) {
                        setInputFieldError("Please enter a valid email id");
                    }
                    else {
                        setInputFieldError("");
                    }
                }, errorText: inputFieldError, placeholder: "Enter Email", id: "searchText", name: "searchText", required: true, autoComplete: "off", lable: false, showLabel: false, placeholderClassName: "DMSanN_16_400 d-flex", className: "", disabled: isOTPsent, pattern: emailRegex })),
        isOTPsent ? (React.createElement("div", { className: "otp-block" },
            React.createElement("div", { className: "txt_primaryGrey DMSanN_16_400 mb-2" }, "Enter OTP"),
            React.createElement("div", { className: "txt_secondary-gray DMSanM_14_500 mb-2" }, "We've sent you an OTP on your email ID, please enter that OTP"),
            React.createElement(YobInputField, { onChange: function (value) {
                    setOtpError(false);
                    setOtp(value);
                    if ((value === null || value === void 0 ? void 0 : value.length) == 4) {
                        verifyOtp(value);
                    }
                }, type: "number", defaultValue: "", min: 0, max: 1, id: "otp", resetOTP: (otp === null || otp === void 0 ? void 0 : otp.length) === 0 }),
            otpTimer ? (React.createElement("div", { className: "d-flex align-items-center timer-block DMSanN_14_400 mt-2" },
                React.createElement("i", { className: "edel-icon-timeout-holding me-1" }),
                " Resend OTP in",
                " ",
                React.createElement(Timmer, { min: 1, sec: 30, onTimerClose: function () {
                        setOtpTimer(false);
                    } }))) : (React.createElement("div", { className: "d-flex align-items-start justify-content-between flex-row-reverse resend-otp-block mt-2" },
                React.createElement("span", { className: "d-flex align-items-center " },
                    React.createElement("i", { className: "edel-icon-refresh me-1" }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Resend OTP", className: "text-right resend-btn", type: "button", onClick: function () {
                            setOtp("");
                            setOtpError(false);
                            setOtpTimer(true);
                            sendOTPforEmail();
                        } })),
                otpError && (React.createElement("span", { className: "txt-racing-red DMSansNormal_12_400" }, "The OTP is incorrect, Please try again")))),
            React.createElement(EdButton, { className: "w-100 change-email-button", btnTyp: "midnight-blue-border", value: "Back", type: "button", onClick: function () {
                    setIsOTPsent(false);
                    setOtpTimer(false);
                } }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "verify-button-block" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "OTP Verification", type: "button", onClick: function () {
                        if (newEmailID && !inputFieldError) {
                            // setIsOTPsent(true); //
                            checkUCCdedup();
                            // sendOTPforEmail(); //
                        }
                        else if (!newEmailID) {
                            setInputFieldError("Please Enter Email ID");
                        }
                    }, disabled: (inputFieldError === null || inputFieldError === void 0 ? void 0 : inputFieldError.length) > 0 }),
                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", type: "button", onClick: function () {
                        props === null || props === void 0 ? void 0 : props.setverifyEmailPopup(false);
                    } })),
            React.createElement("div", { className: "d-flex align-items-center justify-content-center mt-4 mb-2" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Send Verification Link", type: "button", onClick: function () {
                        // setEmailVerificationSuccess(false);
                        if (newEmailID && !inputFieldError) {
                            checkUCCdedup(true);
                            setInputFieldError("");
                        }
                        else if (!newEmailID) {
                            setInputFieldError("Please Enter Email ID");
                        }
                    } }))))))));
};
export default ClientEmailVerifyPopUp;
